import React from 'react';
import PropTypes from 'prop-types';

export const FormSubmit = ({ children }) => {
  return <div className="swformsubmit">{children}</div>;
};

FormSubmit.propTypes = {
  children: PropTypes.any.isRequired
};
